import FiveCricketGame from "./FiveCricketGame";

// Serves casino/superover and casino/cricketv3 (per-route markup in FiveCricketGame VARIANTS)
export default function SuperOver() {
  return <FiveCricketGame defaultName="superOver" />;
}
